// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2gbBr","sendOtp":"AuthorizeToLogin_sendOtp__1TQzB"};